// extracted by mini-css-extract-plugin
export default {"contactMain":"Contacts_contactMain__zVIo5","contactsMap":"Contacts_contactsMap__fywS7","ourContacts":"Contacts_ourContacts__v1-L9","mapItemsList":"Contacts_mapItemsList__JztU0"};